import React from "react";
import { Outlet } from "react-router-dom";

const PublicLayoutWrapper = () => {
  return <Outlet />;
};

export default PublicLayoutWrapper;
